module.exports = __webpack_public_path__ + "static/media/bust-logo.31a76336.png";